// extracted by mini-css-extract-plugin
export default {"container":"jkB0CZUkt15XaznVko49","imageBlock":"RluwoVHvB5g_Ggq6vugw","infoBlock":"o2FM67qxPYPVVtRyXT3c"};